
import { Helmet } from 'react-helmet';
import CaseStudy, { CASE_STUDY_TYPES } from '../../../components/case-study/CaseStudy';
import Header from '../../../components/Header';
import Layout from '../../../components/Layout';
import ThumbnailImage from '../../../images/thumbnails/ifeat_thumbnail.png';

export function Index() {
  return (
    <Layout
    title="How IFEAT created a branded, high-touch attendee experience with Premagic"
    description="IFEAT (International Federation of Essential Oils and Aroma Trades) is a global network of professionals across the fragrance and flavour supply chain."
    metaImage={ThumbnailImage}
    breadcrumbs={[
      { name: "Home", url: "/" },
      { name: "Case Studies", url: "/case-study/" },
      { name: "IFEAT", url: "/case-study/ifeat/" },
    ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "How IFEAT created a branded, high-touch attendee experience with Premagic",
            "description": "IFEAT (International Federation of Essential Oils and Aroma Trades) is a global network of professionals across the fragrance and flavour supply chain.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.IFEAT} />
    </Layout>
  );
}

export default Index;